module.exports = __webpack_public_path__ + "media/fonts/lineto-circular-book-f25f54b0.ttf";